import type { ActionContext } from 'vuex'

import type { CoreState } from '@/core/store/types'
import type { Location } from '@/core/types'
import { OlympusClient } from '@/OlympusClient'

export interface UpdateLocationHoursParams {
  locationId: string
  newHours: Location['hours']
}

export const updateLocationHours = async (
  { commit }: ActionContext<CoreState, unknown>,
  { locationId, newHours }: UpdateLocationHoursParams
): Promise<void> => {
  const { id, hours } = await OlympusClient.locations.location.updateLocation({
    body: {
      hours: newHours,
    },
    params: {
      locationId,
    },
  })

  commit('UPDATE_LOCATION_HOURS', { id, update: hours })
}
